import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    outerContainer: {
      paddingTop: '1rem',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      paddingBottom: '3.5rem',
    },
    userProfileContainer: {
      padding: '2rem',
      borderRadius: 16,
      boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
      border: '1px solid #eef0f3',
    },
    userProfileContentContainer: {
      display: 'flex',
    },
    userProfileImageError: {
      borderRadius: '100%',
      height: '120px',
      objectFit: 'cover',
      width: '120px',
      border: '3px solid #eef0f3',
      textAlign: 'center',
    },
    userProfileImage: {
      borderRadius: '100%',
      height: '120px',
      objectFit: 'cover',
      width: '120px',
      border: '3px solid #eef0f3',
    },
    userProfileTextContainer: {
      marginLeft: '2.5rem',
    },
    userProfileName: {
      fontSize: '1.5rem',
      fontWeight: 700,
      color: '#1f2937',
      marginBottom: '0.35rem',
    },
    userProfileEmail: {
      fontSize: '0.9rem',
      color: '#6b7280',
    },
    userProfilePhone: {
      fontSize: '0.9rem',
      marginTop: '0.25rem',
      color: '#6b7280',
    },
    userProfileRoleContainer: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      backgroundColor: 'rgba(17, 98, 254, 0.1)',
      borderRadius: 999,
      padding: '4px 12px',
      margin: '0.6rem 0',
    },
    userProfileActionButtonContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '16px',
      marginTop: '0.75rem',
    },
    userProfileRoleIcon: {
      fontSize: '0.9rem',
      color: '#1162FE',
    },
    userProfileRole: {
      fontSize: '0.85rem',
      fontWeight: 600,
      color: '#1162FE',
    },
    userProfileButton: {
      marginTop: '0.5rem',
      textTransform: 'none',
      fontWeight: 600,
      borderRadius: 10,
      width: '210px',
      justifyContent: 'flex-start',
    },
    profileContainer: {
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
    },
    profileImage: {
      height: '40px',
      width: '40px',
      borderRadius: '100%',
    },
    profileNameContainer: {
      marginLeft: '0.5rem',
    },
    profileName: {
      fontSize: '1rem',
    },
    dialogMessageLabel: {
      fontWeight: 'bold',
    },
    activeButton: {
      backgroundColor: '#4caf50',
      '&:hover': {
        backgroundColor: '#357a38',
      },
    },
    blockButton: {
      backgroundColor: '#f44336',
      '&:hover': {
        backgroundColor: '#aa2e25',
      },
    },
    breadcrumbsContainer: {
      position: 'sticky',
      zIndex: '1000',
      top: '0',
      marginTop: '-16px',
      marginLeft: '-25px',
      marginRight: '-25px',
      paddingLeft: '16px',
    },
    breadcrumbsContainerForUsers: {
      position: 'sticky',
      zIndex: '1000',
      top: '75px',
      marginTop: '-16px',
      marginLeft: '-15px',
      marginRight: '-25px',
    },
    breadcrumbsContainerForAdmins: {
      position: 'sticky',
      zIndex: '1000',
      top: '1px',
      marginTop: '-28px',
      marginLeft: '-15px',
      marginRight: '-25px',
    },
    breadcrumbItem: {
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
      color: theme.palette.text.primary,
      padding: '4px 0px',
    },
    activeBreadcrumbItem: {
      color: theme.palette.primary.main,
    },
    breadcrumpIcon: {
      marginRight: '5px',
      fontSize: '18px',
    },
    breadcrumpLabel: {
      fontSize: '14px',
    },
    tabsContainer: {
      margin: '1.25rem 0rem',
      borderRadius: 16,
      boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
      border: '1px solid #eef0f3',
      overflow: 'hidden',
    },
    tabPanelContainer: {
      padding: '0rem',
    },
  };
});
